import React, { Component } from 'react';
import error from '../../img/error.svg';

class Wentwrong extends Component {
    render() {
        return (
            <div>

            <div class="pageerror">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                            <img className="errorIcon" src={error} />  
                            </div>
                            
                        </div>
                    </div>
             </div>
                
            </div>
        );
    }
}

export default Wentwrong;